export default "__VITE_ASSET__gvmpRWvN__"